import { optionsToStrategy } from "@/common/utils/optionsToStrategy"

export const tmaisRafflesStatusOptions = [
  {label: 'Ativo', value: 'active'},
  {label: 'Inativo', value: 'disabled'},
]

export const tmaisRafflesStatusStrategy = optionsToStrategy(tmaisRafflesStatusOptions)